import { isPublicContPath } from '~/utils/auth-routing'
import { isPlatformMarketingPath } from '~/utils/marketingPaths'

export default defineNuxtRouteMiddleware(async (to) => {
  const domain = await ensureShopDomainResolved()
  if (isPlatformMarketingPath(to.path, Boolean(domain.shop))) return
  if (to.path.startsWith('/platform') || /\/admin(\/|$)/.test(to.path) || isPublicContPath(to.path)) {
    return
  }

  const { fetchSettings } = useSiteSettings()
  await fetchSettings()
})
